module.exports = __webpack_public_path__ + "img/thumbnail_MuteSwan_f_normal.896320cf.png";